/**
 * 陕西商贸定制
 */


//获取电子资源分类信息
API.reqElectronicResourcesTabList = () => ajax.get(`/pycustomizedservice/sxtc/literature/classification/`)
//获取电子资源列表
API.reqElectronicResourcesList = (data) => ajax.get(`/pycustomizedservice/sxtc/literature/`, data)
//获取全部电子图书
API.reqAllElectronicBookList = (data) => ajax.get(`/pycustomizedservice/sxtc/allbooks/`, data)
//获取行知电子图书
API.reqZxElectronicBookList = (data) => ajax.get(`/pycustomizedservice/sxtc/sqlbookslist/`, data)
//获取畅想之星电子图书
API.reqCxzxElectronicBookList = (data) => ajax.get(`/pycustomizedservice/sxtc/searchList/`, data)